












































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Groupe from '@/components/Groups/Groupe.vue'
import { getBoUrl } from '@/api/http-constants'
import { ApiService } from '@/api/api.service'
import { IGroup } from '@/types/group'
import { groupNames } from '@/data/group-names'
import Alert from '@/components/Alert.vue'
import orderBy from 'lodash/orderBy'
import take from 'lodash/take'
import { UserModule } from '@/store/modules/user'
import { Image } from '../../types/image'
import GroupImageSelector from '@/components/Groups/GroupImageSelector.vue'
import { tooltipTailleCopro } from '@/data/tooltips'

@Component({
    components: {
        Groupe,
        Alert,
        GroupImageSelector,
    },
})
export default class InfosGroup extends Vue {
    @Prop() private group: any
    @Prop() private classNames: string

    selectedImage: Image | null = null
    showGroupForm = true
    apiService = new ApiService()
    boUrl = getBoUrl()
    pGroup = null
    userID: number
    newGroup: IGroup = {
        operation: null,
        sharedSpace: null,
        owner: null,
        name: null,
        pixabay: null,
        motiviation: null,
        description: null,
        wishedCopros: null,
        surface: null,
        isExterior: 0,
    }

    groupNames = groupNames

    get hobbies() {
        /**
         * On compte les hobbies
         */
        let hobbies = {}
        this.group.users.forEach(user => {
            if (user.hobbies) {
              user.hobbies.forEach(hobby => {
                  if (!hobbies[hobby.name]) {
                      hobbies[hobby.name] = 1
                  } else {
                      hobbies[hobby.name]++
                  }
              })
            }
        })

        /**
         * On transform en tableau
         */
        const hobbiesArray = Object.keys(hobbies).map(x => {
            return {
                name: x,
                count: hobbies[x],
            }
        })

        // On trie du plus grand au plus petit
        const hobbiesFinal = orderBy(hobbiesArray, ['count'], ['desc'])

        // On limit à 5 items
        const hobbiesFirst5 = take(hobbiesFinal, 5)

        return hobbiesFirst5
    }

    get isOwner(): boolean {
        return this.group.group.owner.id === this.userID
    }

    async handleEdit() {
        console.log('edit')

        const _req = {
            name: this.newGroup.name,
            motivation: this.newGroup.motiviation,
            description: this.newGroup.description,
            wishedCopros: this.newGroup.wishedCopros,
            surface: this.newGroup.surface,
        }
        const req = this.selectedImage
            ? {
                  ..._req,
                  pixabay: this.selectedImage.webformatURL,
              }
            : _req

        const resp = await this.apiService.patchGroup(this.group.group.id, req)
        const group = resp.data

        // on met à jour les données du groupe
        this.pGroup.group = group

        // (<Alert>this.$refs.alert).handleAlert("success", 'Enregistrement effectué');
        ;(<any>$(this.$refs.editModal)).modal('hide')
        ;(<any>$(this.$refs.editModal)).on('hidden.bs.modal', this.showInfo)
    }

    showInfo() {
        ;(<any>$(this.$refs.editModal)).off('hidden.bs.modal', this.showInfo)
        ;(<any>$(this.$refs.infoEditModal)).modal('show')
    }

    @Watch('group', { deep: true, immediate: true })
    onGroup(group) {
        if (!group) {
            return
        }
        console.log(group)
        this.pGroup = group
        this.newGroup = {
            operation: group.group.operation.id,
            sharedSpace: group.group.sharedSpace.id,
            owner: group.group.owner.id,
            pixabay: group.group.image,
            motiviation: group.group.motivation,
            isExterior: group.group.isExterior,
            name: group.group.name,
            wishedCopros: group.group.wishedCopros,
            surface: group.group.surface,
            description: group.group.description,
        }

        requestAnimationFrame(() => {
            const $popoverDismiss = $('.popover-dismiss') as any
            $popoverDismiss.popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }

    created() {
        if (UserModule.token == undefined) {
            UserModule.Init()
        }
        this.userID = UserModule.userInfos.id
    }

    async handleQuit() {
        ;(<any>$(this.$refs.quitGroupModal)).modal('hide')
        try {
            await this.apiService.deleteUserFromGroup(
                this.group.group.id,
                this.userID
            )
            this.$router.push({ name: 'groups' })
        } catch (e) {
            console.log(e)
        }
    }
    onSelectedImage(image: Image) {
        this.showGroupForm = true
        this.selectedImage = image
    }
    groupImageURL(value) {
        const id = parseInt(value, 10)
        const boUrl = getBoUrl()
        if (!isNaN(id)) {
            return `${boUrl}images/groups/yvivre-avatar-group-${value}.jpg`
        } else {
            return `${boUrl}${value}`
        }
    }

    get tooltipTailleCopro() {
        return tooltipTailleCopro
    }
}
